module.exports = __webpack_public_path__ + "static/media/IMG_9514.3fdd4625.JPG";